import HttpRequest from './interceptors/index'
import config from '../config/index'

const axios = new HttpRequest(config.baseUrl())

class ApiGuest {
  constructor() {}
  sendPostRequest(url, params = {}) {
    return axios.request({
      url,
      method: 'post',
      data: params
    })
  }
  sendGetRequest(url, params = {}) {
    return axios.request({
      url,
      method: 'get',
      params
    })
  }
}

export default new ApiGuest()
